module.exports = __webpack_public_path__ + "img/4.f837d42e.jpg";